import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import DriverPaymentReport from "@/components/DriverPaymentReport";
import DriverFullReporting from "@/components/DriverFullReporting";
import DriverPdfSummaries from "@/components/DriverPdfSummaries";

interface Props {
  driverName: string;
}

/**
 * DriverReporting groups the driver's three reporting views behind sub-tabs.
 * Drivers only ever see their OWN data because every child component is
 * filtered by `driverName`, which is the signed-in driver's name.
 *
 *  - Weekly      : per-job week view with a week < > picker (existing report)
 *  - Full        : date-range summary of saved weekly summaries, one column
 *                  per deduction, exportable to CSV (month / quarter / year)
 *  - PDF Summaries: search saved summaries by month and open/print the PDF
 */
const DriverReporting: React.FC<Props> = ({ driverName }) => {
  return (
    <Tabs defaultValue="weekly" className="w-full">
      <TabsList className="mb-4">
        <TabsTrigger value="weekly">Driver Reporting (Weekly)</TabsTrigger>
        <TabsTrigger value="full">Full Reporting</TabsTrigger>
        <TabsTrigger value="pdf">PDF Summaries</TabsTrigger>
      </TabsList>

      <TabsContent value="weekly" className="space-y-4">
        <DriverPaymentReport driverName={driverName} />
      </TabsContent>

      <TabsContent value="full" className="space-y-4">
        <DriverFullReporting driverName={driverName} />
      </TabsContent>

      <TabsContent value="pdf" className="space-y-4">
        <DriverPdfSummaries driverName={driverName} />
      </TabsContent>
    </Tabs>
  );
};

export default DriverReporting;
